import Vue from 'vue'
import Router from 'vue-router'
import RouterView from '@/pages/RouterView.vue'
Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    console.log(savedPosition)
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    return position
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: '全景列表',
      redirect: '/pano/tasklist'
    },
    {
      path: '/validationtoken',
      name: '校验token',
      component: resolve => require(['@/pages/ValidationToken.vue'], resolve)
    },
    {
      path: '/pano',
      name: '全景列表',
      redirect: '/pano/tasklist',
      component: RouterView,
      children: [
        {
          path: 'tasklist',
          meta: {
            title: '全景拼接列表'
          },
          component: resolve => require(['@/pages/Pano/Tasklist.vue'], resolve)
        }
        // {
        //   path: 'examples',
        //   meta: {
        //     title: '全景拼接列表'
        //   },
        //   component: resolve => require(['@/components/Helloworld.vue'], resolve)
        // }
      ]
    },
    {
      path: '/model',
      name: '三维重建',
      redirect: '/model/tasklist',
      component: RouterView,
      children: [
        {
          path: 'tasklist',
          meta: {
            title: '三维重建列表'
          },
          component: resolve => require(['@/pages/Model/Tasklist.vue'], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js